import type { ReactNode } from 'react';

export function LegalReferenceBadge({ children }: { children: ReactNode }) {
  return (
    <span className="mx-0.5 inline-block rounded-md border border-border bg-surface-subtle px-1.5 py-0.5 font-mono text-[0.85em] text-text-secondary">
      {children}
    </span>
  );
}
